module.exports = __webpack_public_path__ + "static/media/logo.183c0779.png";